import { PlansEnum } from '@shared/components/select-plan/select-plan/plan-mapper.service';

export const RolePermissions = {
  admin: [
    'read-employees',
    'create-employees',
    'update-employees',
    'delete-employees',

    'read-clients',
    'create-clients',
    'update-clients',
    'delete-clients',

    'read-projects',
    'create-projects',
    'update-projects',
    'delete-projects',

    'read-qualifications',
    'create-qualifications',
    'update-qualifications',
    'delete-qualifications',

    'read-absence-request',
    'create-absence-request',
    'update-absence-request',
    'delete-absence-request',

    'read-absence',
    'create-absence',
    'update-absence',
    'delete-absence'
  ],
  manager: [
    'read-employees',
    'create-employees',
    'update-employees',
    'delete-employees',

    'read-clients',
    'create-clients',
    'update-clients',
    'delete-clients',

    'read-projects',
    'create-projects',
    'update-projects',
    'delete-projects',

    'read-qualifications',
    'create-qualifications',
    'update-qualifications',
    'delete-qualifications',

    'read-absence-request',
    'create-absence-request',
    'update-absence-request',
    'delete-absence-request',

    'read-absence',
    'create-absence',
    'update-absence',
    'delete-absence'
  ],
  worker: ['read-projects', 'read-qualifications', 'create-qualifications', 'update-qualifications', 'update-absence']
};

export const PlanPermissions = {
  [PlansEnum.Trial]: {
    admin: [],
    manager: [],
    worker: []
  },
  [PlansEnum.Lead]: {
    admin: [],
    manager: [],
    worker: []
  },
  [PlansEnum.Free]: {
    admin: [],
    manager: [],
    worker: []
  },
  [PlansEnum.Basis]: {
    admin: ['import-templates'],
    manager: [],
    worker: []
  },
  [PlansEnum.Smart]: {
    admin: [],
    manager: [],
    worker: []
  },
  [PlansEnum.Proff]: {
    admin: [],
    manager: [],
    worker: []
  }
};
